import {Mixin} from "mixwith";

/**
 * Validate
 * Form
 * Some sort of name,value behavior
 *
 * Polymer.IronControlState,
 * - focused
 * - disabled
 *
 * Polymer.IronFormElementBehavior,
 * - name
 * - value
 * - required
 *
 * Polymer.IronValidatableBehavior
 * - validator
 * - invalid
 *
 * Polymer.IronA11yKeysBehavior,
 */
export const MutableMixin = Mixin(superClass => class extends superClass {

	static get properties() {
		return {
			ns: String
		};
	}

	set mutationOptions(options) {
		this.__mutationOptions = Object.assign({}, this.__mutationOptions, options);

		if(this.ns && this.mutationAPI)
			this.mutationAPI.clearMutationOptions(this.ns);
	}

	get mutationOptions() {
		return this.__mutationOptions;
	}

	constructor() {
		super();
		this._beforeRender = true;

		/**
		 * @type {MutationAPI}
		 */
		this.mutationAPI = MutationAPI.GlobalInstance;
	}

	connectedCallback() {
		super.connectedCallback();
		this.register();

		if(this._beforeRender) {
			this.firstUpdatedBeforeRender();
			this._beforeRender = false;
		}
	}

	disconnectedCallback() {
		this.unregister();
		super.disconnectedCallback();
	}

	/**
	 * Invoked when the element is first updated, but before the first rendering.
	 * Implement to perform one time work on the element after update.
	 */
	firstUpdatedBeforeRender() {}

	/**
	 * Registers namespace with this element to the MutationAPI in order to receive updates.
	 */
	register() {
		if(!this.ns) return;
		this.mutationAPI.register(this.ns, this);
	}

	/**
	 * Unregisters namespace from the MutationAPI.
	 */
	unregister() {
		if(!this.ns) return;
		this.mutationAPI.unregister(this.ns);
	}

	/**
	 * Returns if this element is registered in the MutationAPI.
	 *
	 * @return {boolean}
	 */
	isRegistered() {
		return this.mutationAPI.isRegistered(this);
	}

	/**
	 * Checks if the namespace has an initial value.
	 *
	 * @return {boolean}
	 */
	hasInitialValue() {
		return this.mutationAPI.hasInitialValue(this.ns);
	}

	/**
	 * Sets the initial value of the MutationAPI for this namespace.
	 *
	 * @param value
	 */
	setInitialValue(value) {
		if(!this.ns) return;
		this.mutationAPI.setInitialValue(this.ns, value);
	}

	/**
	 * Returns the internal stored initial value of the namespace if defined or undefined otherwise.
	 *
	 * @return {*}
	 */
	getInitialValue() {
		if(!this.ns) return;
		return this.mutationAPI.getInitialValue(this.ns);
	}

	/**
	 * Checks if the namespace has changes.
	 *
	 * @return {boolean}
	 */
	hasChanges() {
		if(!this.ns) return false;
		return this.mutationAPI.hasChanges(this.ns);
	}

	/**
	 * Returns the changes of the namespace if any or undefined otherwise.
	 *
	 * @return {*}
	 */
	getChanges() {
		if(!this.ns) return undefined;
		return this.mutationAPI.getChanges(this.ns);
	}

	/**
	 * Updates the mutated value of the MutationAPI for this namespace.
	 *
	 * @param value
	 */
	updateChanges(value) {
		if(!this.ns) return;
		this.mutationAPI.updateChanges(this.ns, value);
	}

	/**
	 * Sets all changes as the initial state.
	 *
	 * This method may be overridden to add additional save logic.
	 *
	 * @abstract
	 * @param newValue
	 */
	saveChanges(newValue = undefined) {}

	/**
	 * Sets the element back to it's initial/default state.
	 *
	 * This method may be overridden to add additional reset logic.
	 */
	reset() {
		this.resetChanges();
	}

	/**
	 * Resets/Reverts all changes to the initial state.
	 *
	 * Mainly used for internal Mutable*Mixin's reset logic.
	 * Elements which use this mixin should override the reset method.
	 *
	 * @abstract
	 */
	resetChanges() {}

});

export default MutableMixin;